import { render, staticRenderFns } from "./PutOnStockManage.vue?vue&type=template&id=d4b8a4e6&scoped=true&"
import script from "./PutOnStockManage.vue?vue&type=script&lang=js&"
export * from "./PutOnStockManage.vue?vue&type=script&lang=js&"
import style0 from "./PutOnStockManage.vue?vue&type=style&index=0&id=d4b8a4e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b8a4e6",
  null
  
)

export default component.exports